<template>
  <div class='send'>
    <div class="YTitle">消息发送</div>

    <div class="form YFrom2">
      <el-form :model="formInline" :rules="rules" ref="rules" :label-width='`${ 200 / 192 }rem`'>
        <el-form-item label="选择消息模板：" prop="templateId">
          <el-select v-model.trim="formInline.templateId" filterable placeholder="请选择消息模板" @input="templateId">
            <el-option
              v-for="item in DataList"
              :key="item.id"
              :label="item.notifyTitle"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否发送短信：" prop="isSendSms" v-if="nowTemplate.isAddSmsTemplate.type === 1">
          <el-radio-group v-model.trim="formInline.isSendSms">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否有跳转的链接：" prop="isHasUrl">
          <el-radio-group v-model.trim="formInline.isHasUrl">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="跳转链接：" prop="url" v-if="formInline.isHasUrl">
          <el-input v-model.trim="formInline.url" placeholder="请输入消息标题"></el-input>
        </el-form-item>
        <el-form-item label="消息模板："><div v-html="nowTemplate.templateValue"></div></el-form-item>
        <el-form-item
          :label="`${item.field}：`"
          :prop="`paramValue.${index}.value`"
          :rules="{ required: true, message: `${item.field}不能为空`, trigger: 'blur' }"
          v-for="(item, index) in formInline.paramValue"
          :key="index">
          <el-input v-model.trim="item.value"></el-input>
        </el-form-item>
        <el-form-item label="消息发送对象：" prop="notifyObjects">
          <el-button type="primary" @click="Transmit" round>选择对象</el-button>
          <div>
            <el-tag
              class="info-tag"
              type="info"
              v-for="(item, index) in formInline.notifyObjects"
              :key="item.id"
              @close='closeTag(item, index)'
              closable>
              {{item.copyObjName}}
            </el-tag>
          </div>
        </el-form-item>
      </el-form>
    </div>

    <div class="btn">
      <el-button type="primary" round @click="save">发送</el-button>
      <el-button plain round @click="close">取消</el-button>
    </div>

    <Transmit v-if="TransmitShow" @close='TransmitClose' @save='TransmitSave' :data='formInline.notifyObjects'></Transmit>
  </div>
</template>

<script>
import api from '@/shared/api/apps/news'
import deepClone from '@/shared/utils/deep-clone'
import Transmit from './transmit'
export default {
  name: 'Send',

  components: { Transmit },

  data () {
    return {
      nowTemplate: {
        isAddSmsTemplate: {}
      },
      DataList: [],
      TransmitShow: false,
      formInline: {
        templateId: '',
        isSendSms: 0,
        paramValue: [],
        isHasUrl: 0,
        url: '',
        notifyObjects: []
      },
      rules: {
        templateId: [
          { required: true, message: '消息模板不能为空', trigger: 'blur' }
        ],
        isSendSms: [
          { required: true, message: '请选择是否发送短信', trigger: 'blur' }
        ],
        isHasUrl: [
          { required: true, message: '请选择是否有跳转的链接', trigger: 'blur' }
        ],
        url: [
          { required: true, message: '请填写跳转链接', trigger: 'blur' }
        ],
        notifyObjects: [
          { required: true, message: '请选择消息发送对象', trigger: 'blur' }
        ]
      }
    }
  },

  mounted () {
    this.init()
  },

  methods: {
    init () {
      this.getList()
    },

    getList () {
      const params = {
        method: api.list,
        pageNum: 1,
        pageSize: 10000
      }

      this.axios.post(params).then(res => {
        if (res.data.backend_odc_notify_template_page_list_response.code !== '10000') return
        this.DataList = res.data.backend_odc_notify_template_page_list_response.result.records
        if (this.DataList.length === 0) return
        this.formInline.paramValue = deepClone(JSON.parse(this.DataList[0].templateParam))
        this.nowTemplate = this.DataList[0]
        this.formInline.templateId = this.DataList[0].id
      })
    },

    templateId (val) {
      this.DataList.forEach(res => {
        if (res.id === val) {
          this.nowTemplate = res
          this.formInline.paramValue = deepClone(JSON.parse(res.templateParam))
        }
      })
    },

    save () {
      this.$refs.rules.validate((valid) => {
        if (valid) {
          this.$confirm('是否发送该消息?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.submit()
          }).catch(() => {})
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    submit () {
      const params = {
        method: api.send,
        templateId: this.formInline.templateId,
        isHasUrl: this.formInline.isHasUrl
      }

      if (this.formInline.isHasUrl) {
        params.url = this.formInline.url
      }

      if (this.nowTemplate.isAddSmsTemplate.type === 1) {
        params.isSendSms = this.formInline.isSendSms
      }

      if (this.formInline.paramValue.length > 0) {
        params.paramValue = this.formInline.paramValue
      } else {
        params.templateValue = this.nowTemplate.templateValue
      }

      params.notifyObjects = []
      this.formInline.notifyObjects.forEach(res => {
        params.notifyObjects.push({
          targetObjectId: res.copyObjId,
          targetObjectType: res.copyObjType
        })
      })

      this.axios.post(params).then(res => {
        if (res.data.backend_odc_notify_instantiation_add_response.code !== '10000') return
        this.$message({
          message: '消息发送成功',
          type: 'success'
        })
        this.$emit('close', 1)
      })
    },

    Transmit () {
      this.TransmitShow = true
    },

    TransmitClose () {
      this.TransmitShow = false
    },

    TransmitSave (val) {
      const arr = []
      this.formInline.notifyObjects.forEach(res => {
        arr.push(res.id)
      })

      val.forEach(res => {
        if (arr.indexOf(res.id) === -1) {
          this.formInline.notifyObjects.push(res)
        }
      })
      this.TransmitShow = false
    },

    closeTag (item, index) {
      this.formInline.notifyObjects.splice(index, 1)
    },

    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang='stylus' scoped>
  .send
    position absolute
    top 0
    left 0
    width 100%
    height 100%
    background #ffffff
    z-index 1
    display flex
    flex-direction column
    .form
      flex auto
      margin-top 20px
      .info-tag
        margin-right 20px
        margin-top 10px
    .btn
      margin 20px 0
      text-align center
</style>
